module.exports = __webpack_public_path__ + "img/star.bd4827ae.svg";